import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { Footer } from "../../../components/Landing/Footer";
import { Button, Collapse, Modal, Carousel } from "antd";
import { useState, useEffect } from "react";
import collageMentorias from "../../../assets/landing/collage-mentorias.png";
import mentoriaMarca from "../../../assets/landing/mentoriaMarca.png";
import mentoriaDerechos from "../../../assets/landing/mentoriaDerechos.png";
import mentoriaLEP from "../../../assets/landing/mentoriaLEP.png";
import mentoriaOne from "../../../assets/landing/mentoriaOne.png";
import m1 from "../../../assets/landing/mentorias/1.jpg";
import m2 from "../../../assets/landing/mentorias/2.jpg";
import m3 from "../../../assets/landing/mentorias/3.jpg";
import m4 from "../../../assets/landing/mentorias/4.jpg";
import m5 from "../../../assets/landing/mentorias/5.jpg";
import m6 from "../../../assets/landing/mentorias/6.jpg";
import m7 from "../../../assets/landing/mentorias/7.jpg";
import m8 from "../../../assets/landing/mentorias/8.jpg";
import m9 from "../../../assets/landing/mentorias/9.jpg";
import { FaEnvelope, FaQuestionCircle } from "react-icons/fa";

const { Panel } = Collapse;

const MENTORIAS_DATA = [
  {
    tematica: '¿Te vas a presentar por primera vez a las convocatorias? Tenemos el ABC para tu postulación',
    fechaHora: '5:00 p. m. - Martes, 9 de junio de 2026',
    lugar_enlace: 'https://meet.google.com/prq-ayoy-mta',
    materialApoyo: 'https://youtu.be/TL_aGj5NluI',
    modalidad: 'Virtual'
  },
  {
    tematica: '¿Qué debo tener en cuenta para mi postulación a las convocatorias? Hablemos de la documentación necesaria.',
    fechaHora: '5:00 p. m. - Miércoles, 10 de junio de 2026',
    lugar_enlace: 'https://meet.google.com/agi-espx-kqe',
    materialApoyo: 'https://youtu.be/wR2S39U6VCQ',
    modalidad: 'Virtual'
  },
  {
    tematica: 'Hablemos de formulación de proyectos culturales: objetivos, justificación, antecedentes y metodología.',
    fechaHora: '5:00 p. m. - Jueves, 11 de junio de 2026',
    lugar_enlace: 'https://meet.google.com/vng-wdmi-xhk',
    materialApoyo: 'https://youtu.be/btxWnPxeTa4',
    modalidad: 'Virtual'
  },
  {
    tematica: 'Presupuesto y cronograma.',
    fechaHora: '5:00 p. m. - Viernes, 12 de junio de 2026',
    lugar_enlace: 'https://meet.google.com/dkw-tjfj-yeb',
    materialApoyo: 'https://youtu.be/k78iKZivSto',
    modalidad: 'Virtual'
  }
];

export const Mentorias = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const carouselImages = [m1, m2, m3, m4, m5, m6, m7, m8, m9];

  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <style>{`
        .custom-carousel-wrapper .slick-prev:before, 
        .custom-carousel-wrapper .slick-next:before {
          color: #faad14 !important;
          font-size: 30px !important;
        }
        .custom-carousel-wrapper .slick-prev {
          left: -15px;
          z-index: 2;
        }
        .custom-carousel-wrapper .slick-next {
          right: -5px;
          z-index: 2;
        }
        /* Custom styles for dots */
        .custom-carousel-wrapper .ant-carousel .slick-dots {
          bottom: -15px !important;
        }
        .custom-carousel-wrapper .ant-carousel .slick-dots li button {
          background: #faad14 !important;
          opacity: 0.4 !important;
          height: 10px !important;
          width: 10px !important;
          border-radius: 50% !important;
        }
        .custom-carousel-wrapper .ant-carousel .slick-dots li.slick-active button {
          background: #faad14 !important;
          opacity: 1 !important;
          width: 28px !important;
          border-radius: 5px !important;
        }
      `}</style>
      <Header />
      <HeaderScc />
      <Modal
        title={null}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={900}
        centered
        bodyStyle={{ padding: '24px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
            Ya tenemos la agenda de socializaciones para que prepares tu postulación a las Convocatorias de Fomento y Estímulos para el Arte y la Cultura 👇
          </p>
          <p style={{ fontSize: '16px' }}>
            Nos encantaría contar con tu presencia, este será un espacio de encuentro para compartir detalles del lineamiento, solucionar dudas y orientarte en el proceso 🤓📚
          </p>
        </div>
        <div className="custom-carousel-wrapper" style={{ paddingBottom: '20px' }}>
          <Carousel 
            autoplay 
            effect="fade"
            arrows={true}
            dots={true}
          >
            {carouselImages.map((img, idx) => (
              <div key={img}>
                <img src={img} alt={`Mentoría ${idx + 1}`} style={{ width: '100%', maxHeight: '75vh', objectFit: 'contain', margin: '0 auto', display: 'block', borderRadius: '8px' }} />
              </div>
            ))}
          </Carousel>
        </div>
      </Modal>
      <div className="container-fluid2">
        <div className="row">
          <br />
        </div>
        <div className="row" style={{ backgroundColor: '#faad1414' }}>
          <div className="col-md-5 col-sm-12">
            <div className="font-family-Montserrat-Bold text-center font-color-black" style={{ fontSize: 48, position: 'relative', top: '24px' }}>
              <strong>
                Mentorías
              </strong>
            </div>
            <br />
            <br />
            <div className="font-size-24px font-family-Montserrat text-justify font-color-black">
              Es el componente pedagógico del proceso de convocatorias.
              <br />
              Esta es tu oportunidad para adquirir herramientas y conocimientos que potencien tus capacidades para la formulación y presentación de proyectos en las Convocatorias de Fomento y Estímulos al Arte y la Cultura de la ciudad y otros escenarios de participación
            </div>
            <br />
            <div className="text-center" style={{ marginTop: '20px' }}>
              <Button 
                type="primary" 
                size="large" 
                onClick={() => setIsModalVisible(true)} 
                style={{ backgroundColor: '#faad14', borderColor: '#faad14', borderRadius: '8px', fontWeight: 'bold', fontSize: '18px', height: 'auto', padding: '10px 24px' }}
              >
                Ver agenda de socializaciones
              </Button>
            </div>
            <br />
          </div>
          <div className="col-md-7 col-sm-12 justify-content-center">
            <img src={collageMentorias} style={{ maxWidth: '100%' }} alt="Mentorias estimulos cultura medellin"></img>
          </div>
        </div>
        <div className="row" style={{ backgroundColor: '#faad1414' }}>
          <div className="col-12" style={{ padding: '0 40px' }}>
            {/* Tabla de Próximas Mentorías */}
            <div className="row justify-content-center" style={{ padding: '40px 20px' }}>
              <div className="col-12">
                <div className="font-family-Montserrat-Bold text-center font-color-black" style={{ fontSize: 32 }}>
                  <strong>Próximas Mentorías</strong>
                </div>
                <div className="font-family-Montserrat-Bold text-center font-color-black" style={{ fontSize: 25 }}>
                  <strong>Prográmate con las Mentorías colectivas para tu postulación a las Convocatorias de Fomento y Estímulos para el Arte y la Cultura</strong>
                </div>
              </div>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: '10px',
                overflow: 'hidden'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#faad14', color: 'white' }}>
                    <th style={{
                      padding: '5px',
                      textAlign: 'left',
                      fontSize: '20px',
                      borderBottom: '2px solid #e8e8e8'
                    }}
                      className="font-family-Montserrat"
                    >
                      Temática
                    </th>
                    <th style={{
                      padding: '5px',
                      textAlign: 'center',
                      fontSize: '20px',
                      borderBottom: '2px solid #e8e8e8'
                    }}
                      className="font-family-Montserrat">
                      Modalidad
                    </th>
                    <th style={{
                      padding: '5px',
                      textAlign: 'left',
                      fontSize: '20px',
                      borderBottom: '2px solid #e8e8e8'
                    }}
                      className="font-family-Montserrat">
                      Fecha y Hora
                    </th>
                    <th style={{
                      padding: '5px',
                      textAlign: 'center',
                      fontSize: '20px',
                      borderBottom: '2px solid #e8e8e8'
                    }}
                      className="font-family-Montserrat">
                      Lugar / Enlace
                    </th>
                    <th style={{
                      padding: '5px',
                      textAlign: 'center',
                      fontSize: '20px',
                      borderBottom: '2px solid #e8e8e8'
                    }}
                      className="font-family-Montserrat">
                      Material de apoyo
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {MENTORIAS_DATA.map((mentoria, index) => (
                    <tr key={mentoria.tematica || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : 'white' }}>
                      <td style={{
                        padding: '5px',
                        fontSize: '20px',
                        borderBottom: index === MENTORIAS_DATA.length - 1 ? 'none' : '1px solid #e8e8e8'
                      }}
                        className="font-family-Montserrat">
                        <strong>
                          {mentoria.tematica}
                        </strong>
                      </td>
                      <td style={{
                        padding: '5px',
                        fontSize: '15px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        borderBottom: index === MENTORIAS_DATA.length - 1 ? 'none' : '1px solid #e8e8e8'
                      }}
                        className="font-family-Montserrat">
                        {mentoria.modalidad}
                      </td>
                      <td style={{
                        padding: '5px',
                        fontSize: '15px',
                        borderBottom: index === MENTORIAS_DATA.length - 1 ? 'none' : '1px solid #e8e8e8'
                      }}
                        className="font-family-Montserrat">
                        {mentoria.fechaHora}
                      </td>
                      <td style={{
                        padding: '5px',
                        textAlign: 'center',
                        borderBottom: index === MENTORIAS_DATA.length - 1 ? 'none' : '1px solid #e8e8e8'
                      }}>
                        {(() => {
                          if (mentoria.lugar_enlace === 'Pendiente') return <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#666' }}></span>;
                          if (mentoria.lugar_enlace === 'No aplica') return <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#666' }}>No aplica</span>;
                          if (mentoria.lugar_enlace.startsWith('http')) return (
                            <Button type="link" className="button-azul-radius-detalle" style={{ fontSize: '15px' }} onClick={() => window.open(mentoria.lugar_enlace, '_blank')}>
                              <span style={{ fontSize: '15px' }}>Unirse</span>
                            </Button>
                          );
                          return <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>{mentoria.lugar_enlace}</span>;
                        })()}
                      </td>
                      <td style={{
                        padding: '5px',
                        textAlign: 'center',
                        borderBottom: index === MENTORIAS_DATA.length - 1 ? 'none' : '1px solid #e8e8e8'
                      }}>
                        {mentoria.materialApoyo === 'Pendiente' ? (
                          <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#666' }}>Pronto publicaremos este módulo</span>
                        ) : (
                          <Button
                            type="link"
                            className="button-azul-radius-detalle"
                            style={{ fontSize: '15px' }}
                            onClick={() => window.open(mentoria.materialApoyo, '_blank')}
                          >
                            <span style={{ fontSize: '15px' }}>Ver</span>
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div>
          <br />
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-sm-12 text-center cajasMentorias" style={{ backgroundColor: '#7fffd440' }}>
            <div className="font-size-24px font-family-Montserrat text-center font-color-black">
              <strong>¿Qué si es una mentoría?</strong>
              <br />
              Un proceso de orientación y fortalecimiento.
            </div>
          </div>
          <div className="col-12 col-md-6 col-sm-12 justify-content-center cajasMentorias" style={{ backgroundColor: '#ff7f5030' }}>
            <div className="font-size-24px font-family-Montserrat text-center font-color-black">
              <strong>¿Qué NO es una mentoría?</strong>
              <br />
              No garantiza la selección del proyecto, pero sí aporta conocimientos valiosos.
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="row justify-content-center">
          <div className="font-family-Montserrat-Bold text-center font-color-black" style={{ fontSize: "clamp(26px, 7vw, 48px)", lineHeight: 1.2, wordBreak: "break-word" }}>
            <strong>
              ¿Cómo te acompañamos?
            </strong>
          </div>
          <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 26 }}>
            Conoce todas las opciones que tenemos para acompañarte en tu proceso de mentoría
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row justify-content-center text-center" style={{ backgroundColor: 'whitesmoke', padding: 10, borderRadius: 10 }}>
          <div className="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
            <FaEnvelope style={{ fontSize: '44px' }} />
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <p>
                ¿Tienes algún problema?
                <br />
                ¿Hay algo que no comprendes?
                <br />
                ¿Tienes dudas sobre los formularios y la documentación?
              </p>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            mentoriascultura@medellin.gov.co
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row justify-content-center text-center" style={{ backgroundColor: 'whitesmoke', padding: 10, borderRadius: 10 }}>
          <div className="col-md-3 col-sm-12 d-flex justify-content-center align-items-center">
            <FaQuestionCircle style={{ fontSize: '44px', display: 'inline-block', whiteSpace: 'nowrap' }} />
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
            <div className="text-center">
              <p>Si es tu primera vez formulando un proyecto o no conoces de qué se trata el objetivo, la justificación, la metodología y demás componentes básicos de la formulación</p>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            mentoriascultura@medellin.gov.co
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />

        <div className="justify-content-center" style={{ backgroundColor: '#f3f4f6', padding: 20 }}>
          <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 30 }}>
            <strong>Participa de nuestros programas de acompañamiento</strong>
          </div>
        </div>
        <div className="row justify-content-center" style={{ backgroundColor: '#f3f4f6' }}>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaMarca}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de infraestructura</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaDerechos}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de audiovisuales</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaLEP}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de gestión cultural</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="card3-container">
              <div className="card2">
                <img
                  src={mentoriaOne}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Mentorías de artes plásticas y visuales</h3>
                  <p className="card2-description">
                    Virtual
                  </p>
                  <p className="card2-description">
                    Fechas disponibles
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 30 }}>
          <strong>Consejos para participar</strong>
        </div>
        <Collapse accordion>
          <Panel header="1. Analiza" key="1">
            <p>Lee atentamente la convocatoria, conoce sus detalles, identifica los requisitos y documentos solicitados, revisa los formularios. Si tienes dudas, escríbenos a convocatorias.cultura@medellin.gov.co</p>
          </Panel>
          <Panel header="2. Analiza" key="2">
            <p>Explora la plataforma y familiarízate con su funcionamiento (sobre todo si es tu primera vez). Necesitas soporte con la plataforma, escríbenos a convocatorias.cultura@medellin.gov.co</p>
          </Panel>
          <Panel header="3. Estructura tu proyecto" key="3">
            <p>Diligencia los formularios y recolecta la documentación necesaria. Si no sabes cómo hacer un objetivo, la justificación u otros elementos de la formulación, escríbenos a mentoriascultura@medellin.gov.co</p>
          </Panel>
          <Panel header="4. Chequea" key="4">
            <p>Verifica que tienes los documentos solicitados, evalúa tu proyecto y realiza ajustes. Conversa con colegas y amigos, piensa quiénes pueden ayudarte a revisar tu proyecto.</p>
          </Panel>
          <Panel header="5. Inscribe" key="5">
            <p>Tu propuesta con tiempo en la plataforma ¡No lo dejes para el último día!</p>
          </Panel>
        </Collapse>
      </div >
      <Footer />
    </>
  );
};
